import axios from 'axios';
import { create } from 'zustand';
import { deleteCookie, getCookie, setCookie } from '../utils/cookies';
import localStorageUtil from '../utils/localStorage';
import { useRBACStore } from './useRBACStore';

export const USER_DETAILS_KEY = 'userDetails';
export const ACCESS_TOKEN_KEY = 'accessToken';

export const useAuthStore = create((set, get) => ({
  user: localStorageUtil.getItem(USER_DETAILS_KEY) || null,
  token: getCookie(ACCESS_TOKEN_KEY) || null,
  isAuthenticated: !!getCookie(ACCESS_TOKEN_KEY),

  login: (data) => {
    const token = data?.accessToken;
    if (!token) {
      console.error('Login failed: Access token missing');
      return;
    }

    setCookie(ACCESS_TOKEN_KEY, token);
    localStorageUtil.setItem(USER_DETAILS_KEY, data);

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // ✅ Sync roles & privileges
    useRBACStore.getState().setRolesAndPrivileges(data.rolesPrivileges || []);

    set({
      user: data,
      token,
      isAuthenticated: true,
    });
  },

  logout: () => {
    deleteCookie(ACCESS_TOKEN_KEY);
    localStorage.removeItem(USER_DETAILS_KEY);

    delete axios.defaults.headers.common['Authorization'];

    // Clear RBAC state too
    useRBACStore.getState().clear();

    set({
      user: null,
      token: null,
      isAuthenticated: false,
    });
  },

  // REFRESH STATE (for storage sync)
  refreshAuthFromStorage: () => {
    const token = getCookie(ACCESS_TOKEN_KEY);
    const user = localStorageUtil.getItem(USER_DETAILS_KEY);

    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      set({ token, user, isAuthenticated: true });
      if (user) {
        useRBACStore.getState().setRolesAndPrivileges(user.rolesPrivileges || []);
      }
    } else {
      delete axios.defaults.headers.common['Authorization'];
      set({ token: null, user: null, isAuthenticated: false });
      useRBACStore.getState().clear();
    }
  },
}));
